export enum BOOKINGTYPE {
  Individual,
  Group,
}
